var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.1a3.1 3.1 0 1 0 0-6.2a3.1 3.1 0 0 0 0 6.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.5h1.4l.42 2.26c.45.14.88.32 1.29.54l1.91-1.28l1 1l1 1l-1.28 1.91c.22.41.4.84.54 1.29l2.26.42v2.8l-2.26.42c-.14.45-.32.88-.54 1.29l1.28 1.91l-2 2l-1.91-1.28c-.41.22-.84.4-1.29.54l-.42 2.26h-2.8l-.42-2.26a6.97 6.97 0 0 1-1.29-.54l-1.91 1.28l-2-2l1.28-1.91a6.97 6.97 0 0 1-.54-1.29l-2.26-.42v-2.8l2.26-.42c.14-.45.32-.88.54-1.29L4.98 7.02l2-2L8.89 6.3c.41-.22.84-.4 1.29-.54l.42-2.26H12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.cda9d121f9d22e124b60c7813792cab6.svg";
export { ForwardRef as ReactComponent };